import React, { useRef, useState, useCallback, useEffect } from "react";
import Styles from "./Element.module.css";
import Fileupload from "../../../../commons/Inputs/FileUpload/Fileupload";
import TextInput from "../../../../commons/Inputs/TextInput/TextInput";
import { useDispatch, useSelector } from "react-redux";
import SelectInput from "../../../../commons/Inputs/Select/SelectInput";
import {
  getDiscomByStateId,
  getStateByRegionId,
} from "../../../../Services/ApiCalling/PublicApi";
import { Add, Close } from "@mui/icons-material";
import DeleteIcon from "@mui/icons-material/Delete";
import { verifyConsumerName } from "../../../../Services/ApiCalling/Auth";
import { decryptData } from "../../../../commons/Decode";
import {
  publicCityById,
  publicDiscomByStateId,
  publicStateByRegionId,
} from "../../../../Redux/Slices/publicSlice";
import { ReactComponent as RemoveIcon } from "../../../../assets/images/Remove.svg";
import { toast } from "react-toastify";
import { toastProperties } from "../../../../commons/Toast/Toaster";

const AddressSection = ({
  prefix,
  addressData,
  handleChange,
  errors,
  publicData,
  index,
}) => {
  const dispatch = useDispatch();

  const handleGetCityByStateId = (index, field, value) => {
    dispatch(publicCityById(value?.id));
    handleChange(index, field, value);
  };
  const renderTextInput = (
    field,
    heading,
    example,
    type = "text",
    readOnly = false,
  ) => (
    <TextInput
      heading={`${heading} `}
      value={addressData[field]}
      onChange={(value) => handleChange(index, field, value)}
      example={example}
      type={type}
      height="45"
      error={errors[field]}
      readOnly={readOnly}
    />
  );

  const renderSelectInput = (field, heading, list, example) => (
    <SelectInput
      onChange={(value) =>
        heading === "State"
          ? handleGetCityByStateId(index, field, value)
          : handleChange(index, field, value)
      }
      list={list}
      value={addressData[field]}
      example={example}
      heading={`${heading} `}
      height="45px"
      error={errors[field]}
    />
  );

  return (
    <>
      <div className={Styles.layer1ElementsContainer}>
        {renderTextInput(`${prefix}_address`, "Full Address", `Enter Address`)}
      </div>
      <div className={Styles.layer3ElementsContainer}>
        {renderTextInput(`${prefix}_pincode`, "Pin Code", "Enter Pincode")}
        {renderSelectInput(
          `${prefix}_state`,
          "State",
          publicData?.stateUT,
          "Eg. Select State",
        )}
        {renderSelectInput(
          `${prefix}_city`,
          "City",
          publicData?.city?.filter(
            (ele) => ele?.stateUtId === addressData[`${prefix}_state`]?.id,
          ),
          "Eg. Select City",
        )}
      </div>

      <div className={Styles.layer2ElementsContainer}>
        {renderTextInput(
          `${prefix}_contact`,
          "Name of the Contact Person",
          "Enter Contact Person Name",
        )}
        {renderTextInput(`${prefix}_email`, "Email", "Enter Email")}
      </div>
      <div className={Styles.layer2ElementsContainer}>
        {renderTextInput(`${prefix}_mobile`, "Mobile No.", "Enter Mobile No.")}
        {renderTextInput(
          `${prefix}_altMobile`,
          "Alternate Mobile No.",
          "Enter Alternate Mobile No.",
        )}
      </div>
    </>
  );
};

const ConsumerDetails = ({ userData, handleData, handleProceed }) => {
  const dispatch = useDispatch();
  const [addressData, setAddressData] = useState({});
  const [sameCheck, setSameCheck] = useState("same");

  const initialConsumerDetail = useCallback(() => {
    const defaultDetail = userData?.consumerDetails?.[0] || {};
    return {
      plantName: defaultDetail.plantName || "",
      maxDrawal: defaultDetail.maxDrawal || "",
      poi: defaultDetail.poi || "",
      specification: defaultDetail.specification || {},
      region: defaultDetail.region || {},
      state: defaultDetail.state || {},
      discom: defaultDetail.discom || [],
      discomName: defaultDetail.discomName || {},
      discomVoltage: defaultDetail.discomVoltage || [],
      istsVoltage: defaultDetail.istsVoltage || [],
      stuVoltage: defaultDetail.stuVoltage || [],
      stateList: defaultDetail.stateList || [],
      discomList: defaultDetail.discomList || [],
      bankName:
        defaultDetail?.bankName || userData?.userCompany?.bankName || "",
      payee: defaultDetail?.payee || userData?.userCompany?.payee || "",
      branchAddress:
        defaultDetail?.bankAddress || userData?.userCompany?.bankAddress || "",
      accountNumber:
        defaultDetail?.accountNo || userData?.userCompany?.accountNo || "",
      ifscCode: defaultDetail?.ifsc || userData?.userCompany?.ifsc || "",
      bankDifferent: false,
      pan: defaultDetail?.pan || userData?.userCompany?.pan || "",
      gst: defaultDetail?.gst || userData?.userCompany?.gst || "",
      tan: defaultDetail?.tan || userData?.userCompany?.tan || "",
      panDocId: defaultDetail?.panDocId || userData?.documentList?.pan || "",
      gstDocId: defaultDetail?.gstDocId || userData?.documentList?.gst || "",
      tanDocId: defaultDetail?.tanDocId || userData?.documentList?.tan || "",

      registered_address: userData?.address?.[0]?.address || "",
      registered_state: userData?.address?.[0]?.state || {},
      registered_city: userData?.address?.[0]?.city || {},
      registered_pincode: userData?.address?.[0]?.pincode || "",
      registered_tel: userData?.address?.[0]?.tel || "",
      registered_email: userData?.address?.[0]?.email || "",
      registered_fax: userData?.address?.[0]?.fax || "",
      registered_contact: userData?.address?.[0]?.contact || "",
      registered_contactPhone: userData?.address?.[0]?.contactPhone || "",
      registered_mobile:
        userData?.address?.[0]?.mobile || userData?.phone || "",
      registered_altMobile:
        userData?.address?.[0]?.altMobile || userData?.phone || "",
      correspondence_address: userData?.address?.[1]?.address || "",
      correspondence_state: userData?.address?.[1]?.state || {},
      correspondence_city: userData?.address?.[1]?.city || {},
      correspondence_pincode: userData?.address?.[1]?.pincode || "",
      correspondence_tel: userData?.address?.[1]?.tel || "",
      correspondence_email: userData?.address?.[1]?.email || "",
      correspondence_fax: userData?.address?.[1]?.fax || "",
      correspondence_contact: userData?.address?.[1]?.contact || "",
      correspondence_contactPhone: userData?.address?.[1]?.contactPhone || "",
      correspondence_mobile:
        userData?.address?.[1]?.mobile || userData?.phone || "",
      correspondence_altMobile:
        userData?.address?.[1]?.altMobile || userData?.phone || "",
    };
  }, [userData]);

  const publicData = useSelector((state) => state?.publicSlice);
  const debounceTimeout = useRef(null);

  // State management
  const [totalLength, setTotalLength] = useState(["Consumer Details"]);
  const [errors, setErrors] = useState({});
  const [consumerDetails, setConsumerDetails] = useState(
    userData?.consumerDetails?.length
      ? userData.consumerDetails
      : [initialConsumerDetail()],
  );

  const [discomVoltage, setDiscomVoltage] = useState({
    discomId: {},
    voltage: {},
  });
  const formatFieldName = (field) =>
    field.replace(/([A-Z])/g, " $1").replace(/^./, (str) => str.toUpperCase());

  const handleFieldChange = (index, field, value) => {
    const updatedDetails = [...consumerDetails];
    updatedDetails[index][field] = value;
    setConsumerDetails(updatedDetails);

    setErrors((prevErrors) => {
      const newErrors = { ...prevErrors };
      delete newErrors[`${field}_${index}`];
      return newErrors;
    });

    handleData("consumerDetails", updatedDetails);
  };

  const validateFields = () => {
    const consumerErrors = {};

    consumerDetails.forEach((detail, index) => {
      const requiredFields = [
        "plantName",
        "maxDrawal",
        "poi",
        "specification",
        "region",
        "state",
      ];

      requiredFields.forEach((field) => {
        if (
          !detail[field]?.id &&
          field !== "plantName" &&
          field !== "maxDrawal" &&
          field !== "poi"
        ) {
          consumerErrors[`${field}_${index}`] = `${formatFieldName(
            field,
          )} is required`;
        } else if (
          (field === "plantName" || field === "maxDrawal") &&
          !detail[field]
        ) {
          consumerErrors[`${field}_${index}`] = `${formatFieldName(
            field,
          )} is required`;
        } else if (field === "poi" && !detail[field]) {
          consumerErrors[`${field}_${index}`] = `${formatFieldName(
            field,
          )} is required`;
        }
      });

      // --- DISCOM COMBINATION VALIDATION ---
      // Only validate DISCOM combinations when POI is set to "DISCOM"
      if (detail.poi === "DISCOM") {
        if (
          !detail.discom ||
          !Array.isArray(detail.discom) ||
          detail.discom.length === 0
        ) {
          consumerErrors[`discom_${index}`] =
            "At least one State-Discom-Voltage combination is required";
        } else {
          const getDiscomId = (obj) => obj?.id ?? obj?.discomId;
          const invalidCombos = detail.discom.filter(
            (combo) =>
              !combo.state?.id ||
              !getDiscomId(combo.discomId) ||
              !combo.voltage?.id,
          );
          if (invalidCombos.length > 0) {
            consumerErrors[`discom_${index}`] =
              "All discom combinations must have State, Discom, and Voltage selected";
          }
        }
      }
    });

    setErrors(consumerErrors);
    return Object.keys(consumerErrors).length === 0;
  };

  const handleChange = async (index, type, value, fetchFunction) => {
    const updatedConsumerDetails = [...consumerDetails];

    if (type === "poi") {
      const voltageType = `${value.toLowerCase()}Voltage`;
      if (!updatedConsumerDetails[index][voltageType]) {
        updatedConsumerDetails[index][voltageType] = [];
      }
    }

    updatedConsumerDetails[index][type] = value;

    if (type === "plantName") {
      if (debounceTimeout.current) clearTimeout(debounceTimeout.current);

      debounceTimeout.current = setTimeout(async () => {
        const currentName = updatedConsumerDetails[index]?.plantName?.trim();
        if (currentName) {
          const response = await verifyConsumerName(currentName);
          const decryptedData = decryptData(response?.data);

          setErrors((prevErrors) => {
            const newErrors = { ...prevErrors };
            if (decryptedData?.code !== 200) {
              newErrors[`plantName_${index}`] = decryptedData?.error;
            } else {
              delete newErrors[`plantName_${index}`];
            }
            return newErrors;
          });
        }
      }, 5000);
    }

    setConsumerDetails(updatedConsumerDetails);
    setErrors((prev) => {
      const newErrors = { ...prev };
      delete newErrors[`${type}_${index}`];
      return newErrors;
    });

    // Pass updated data to parent component
    handleData("consumerDetails", updatedConsumerDetails);
  };

  const handleDiscomChange = (index, type, value) => {
    if (type === "discomId") {
      setDiscomVoltage((prev) => ({ ...prev, discomId: value, voltage: {} }));
      // Also update discomName in consumerDetails so voltage selection can reference it
      const updatedConDetails = [...consumerDetails];
      updatedConDetails[index].discomName = value;
      setConsumerDetails(updatedConDetails);
      return;
    }

    if (type === "voltage" && value?.id) {
      const updatedConDetails = [...consumerDetails];
      const discomNameObj = consumerDetails[index]?.discomName || {};
      const normalizedDiscomId = {
        id: discomNameObj.discomId || discomNameObj.id,
        acronym: discomNameObj.acronym || discomNameObj.name,
      };

      // Guard: Discom must be selected before adding voltage
      if (!normalizedDiscomId.id) {
        toast.error(
          "Please select a Discom before selecting a Voltage level",
          toastProperties,
        );
        return;
      }

      const discomObject = {
        state: consumerDetails[index].state,
        discomId: normalizedDiscomId,
        voltage: value,
      };

      // Check for duplicate voltage level for the same DISCOM
      const duplicateVoltageForDiscom = updatedConDetails[index].discom?.find(
        (item) =>
          item.discomId?.id === normalizedDiscomId?.id &&
          item.voltage?.id === value?.id,
      );

      if (duplicateVoltageForDiscom) {
        toast.error(
          `Voltage level "${value.level}" is already selected for this DISCOM`,
          toastProperties,
        );
        return;
      }

      updatedConDetails[index].discom = [
        ...(Array.isArray(updatedConDetails[index].discom)
          ? updatedConDetails[index].discom
          : []),
        discomObject,
      ];
      setDiscomVoltage({ discomId: {}, voltage: {} });
      setConsumerDetails(updatedConDetails);
      handleData("consumerDetails", updatedConDetails);
    }
  };

  const handleContinue = (data) => {
    if (data === "next" && !validateFields()) return;
    handleData("consumerDetails", consumerDetails);
    handleProceed(data);
  };

  const handleAddUser = () => {
    setTotalLength((prev) => [...prev, "Consumer Details"]);
    setConsumerDetails((prev) => {
      const baseConsumer = prev[0] || initialConsumerDetail();
      const newConsumer = JSON.parse(JSON.stringify(baseConsumer));
      const updatedList = [...prev, newConsumer];
      handleData("consumerDetails", updatedList);
      return updatedList;
    });
  };

  const handleRemoveUser = (index) => {
    if (consumerDetails.length > 1) {
      const updatedDetails = consumerDetails.filter((_, i) => i !== index);
      setConsumerDetails(updatedDetails);
      setTotalLength((prev) => prev.filter((_, i) => i !== index));
      handleData("consumerDetails", updatedDetails);

      const updatedErrors = { ...errors };
      Object.keys(updatedErrors).forEach((key) => {
        if (key.endsWith(`_${index}`)) {
          delete updatedErrors[key];
        }
        if (key.includes("_") && parseInt(key.split("_").pop()) > index) {
          const newKey = key.replace(
            /_\d+$/,
            `_${parseInt(key.split("_").pop()) - 1}`,
          );
          updatedErrors[newKey] = updatedErrors[key];
          delete updatedErrors[key];
        }
      });
      setErrors(updatedErrors);
    }
  };

  useEffect(() => {
    if (Array.isArray(userData?.consumerDetails)) {
      setConsumerDetails(
        userData.consumerDetails.length > 0
          ? userData.consumerDetails
          : [initialConsumerDetail()],
      );
    }
  }, [userData?.consumerDetails, initialConsumerDetail]);

  const handleGetStateByRegionId = (id) => {
    dispatch(publicStateByRegionId(id?.id));
  };
  const handleGetDiscomByStateId = (id) => {
    dispatch(publicDiscomByStateId(id?.id));
  };
  // Render helper components
  const renderTextInput = (
    index,
    field,
    heading,
    example,
    type = "text",
    readOnly = false,
  ) => (
    <TextInput
      heading={`${heading}`}
      value={consumerDetails[index][field]}
      onChange={(value) => handleChange(index, field, value)}
      example={example}
      type={type}
      height="45"
      error={errors[`${field}_${index}`]}
      readOnly={readOnly}
    />
  );

  const renderSelectInput = (
    index,
    type,
    list,
    example,
    heading,
    recurring,
  ) => (
    <SelectInput
      onChange={(value) =>
        recurring === "discom"
          ? handleDiscomChange(index, type, value)
          : handleChange(
              index,
              type,
              value,
              type === "region"
                ? handleGetStateByRegionId(value)
                : type === "state"
                  ? handleGetDiscomByStateId(value)
                  : null,
            )
      }
      list={list}
      value={discomVoltage[type] || consumerDetails[index][type]}
      example={example}
      heading={`${heading}`}
      height="45px"
      error={errors[`${type}_${index}`]}
    />
  );

  const renderFileUpload = (index, heading, field, example, type, ID) => (
    <Fileupload
      heading={heading}
      value={consumerDetails[index][field]}
      onChange={(value) => handleFieldChange(index, field, value)}
      height="45"
      example={example}
      type={type}
      id={ID}
      error={errors[`${field}_${index}`]}
    />
  );

  const renderConsumerDetail = (ele, index) => (
    <div className={Styles.multiLayerContainer} key={index}>
      <div className={`${Styles.alterSection} ${Styles.alterSectionOther}`}>
        {totalLength.length > 1 && (
          <div
            className={Styles.deleteSection}
            onClick={() => handleRemoveUser(index)}
          >
            <RemoveIcon style={{ fontSize: "16px" }} />
          </div>
        )}
        <div
          className={`${Styles.addSection} ${Styles.AddnewGenSection}`}
          onClick={handleAddUser}
        >
          <Add style={{ fontSize: "14px" }} />
          <span className={Styles.addNewHeading}>Add New Consumer</span>
        </div>
      </div>

      {/* Basic Details */}
      <div className={Styles.layer2ElementsContainer}>
        {renderTextInput(index, "plantName", "Consumer Name", "Eg. GNA Energy")}
        {renderTextInput(
          index,
          "maxDrawal",
          "Maximum Capacity of Drawal (MW)",
          "Eg. 1000000",
        )}
      </div>

      {/* Specification and Region */}
      <div className={Styles.layer2ElementsContainer}>
        {renderSelectInput(
          index,
          "specification",
          publicData?.specification?.filter((ele) => ele?.type === "CONSUMER"),
          "Select Specification",
          "Specification",
        )}
        {renderSelectInput(
          index,
          "region",
          publicData?.region,
          "Select Region",
          "Region",
        )}
      </div>

      {/* Point of Drawal Section */}
      <div className={Styles.layer3ElementsContainer}>
        <div className={Styles.checkBoxElem}>
          <div className={Styles.checkBoxHead}>Point Of Drawal (POD)*</div>
          <div className={Styles.selectCheckElemEent}>
            {["ISTS", "STU", "DISCOM"].map((poiType) => (
              <div
                key={poiType}
                onClick={() => handleChange(index, "poi", poiType)}
                style={{ width: "30%" }}
                className={
                  consumerDetails[index].poi === poiType
                    ? Styles.activeCheck
                    : Styles.inactiveCheck
                }
              >
                {poiType}
              </div>
            ))}
          </div>
          {errors[`poi_${index}`] && (
            <span className={Styles.errorPass}>{errors[`poi_${index}`]}</span>
          )}
        </div>

        {/* Voltage Selection */}
        <div>
          {(consumerDetails[index].poi === "ISTS" ||
            consumerDetails[index].poi === "STU") && (
            <SelectInput
              onChange={(value) => {
                const updatedVoltages = [...consumerDetails];
                const voltageType = `${consumerDetails[
                  index
                ].poi.toLowerCase()}Voltage`;

                if (!updatedVoltages[index][voltageType]) {
                  updatedVoltages[index][voltageType] = [];
                }

                // Get current voltage list
                const currentVoltages = updatedVoltages[index][voltageType];

                // Check if voltage is already selected
                const isAlreadySelected = currentVoltages.some(
                  (v) => (v?.id || v) === (value?.id || value),
                );

                if (isAlreadySelected) {
                  // Remove voltage if already selected
                  updatedVoltages[index][voltageType] = currentVoltages.filter(
                    (v) => (v?.id || v) !== (value?.id || value),
                  );
                } else {
                  // Add voltage if not already selected
                  updatedVoltages[index][voltageType] = [
                    ...currentVoltages,
                    value,
                  ];
                }

                setConsumerDetails(updatedVoltages);
                handleData("consumerDetails", updatedVoltages);
              }}
              list={publicData?.voltage}
              value={{}}
              example={"Select Voltage Levels"}
              heading={`${consumerDetails[index].poi} Voltage`}
              height={"45px"}
              multiple
            />
          )}
        </div>

        {/* Voltage Display */}
        {(consumerDetails[index].poi === "ISTS" ||
          consumerDetails[index].poi === "STU") && (
          <div className={Styles.layerscrollElements}>
            {(Array.isArray(
              consumerDetails[index][
                `${consumerDetails[index].poi.toLowerCase()}Voltage`
              ],
            )
              ? consumerDetails[index][
                  `${consumerDetails[index].poi.toLowerCase()}Voltage`
                ]
              : []
            ).map((ele, voltageIndex) => (
              <div key={voltageIndex} className={Styles.eachLevelLayer}>
                <span>{ele.level}</span>
                <Close
                  style={{ fontSize: "14px", cursor: "pointer" }}
                  onClick={() => {
                    const updatedVoltages = [...consumerDetails];
                    const voltageType = `${consumerDetails[
                      index
                    ].poi.toLowerCase()}Voltage`;
                    updatedVoltages[index][voltageType] = updatedVoltages[
                      index
                    ][voltageType].filter((_, i) => i !== voltageIndex);
                    setConsumerDetails(updatedVoltages);
                    handleData("consumerDetails", updatedVoltages);
                  }}
                />
              </div>
            ))}
          </div>
        )}
      </div>

      <div className={Styles.divider}></div>

      {/* Discom Selection */}
      <div className={Styles.discomSelectionContainer}>
        <div className={Styles.subConterntHeader}>Discom Voltage</div>
        <div className={Styles.layer3ElementsContainer}>
          {renderSelectInput(
            index,
            "state",
            publicData?.stateUT,
            "Select State",
            "State",
          )}
          {renderSelectInput(
            index,
            `discomId`,
            publicData?.discom || [],
            "Select Discom",
            "Discom",
            "discom",
            discomVoltage?.discomId,
          )}
          {renderSelectInput(
            index,
            `voltage`,
            publicData?.voltage,
            "Select Voltage Level",
            "Voltage Level",
            "discom",
            discomVoltage?.voltage,
          )}
        </div>

        <div className={Styles.voltageOverflow}>
          {consumerDetails[index]?.discom?.map((ele, discomIndex) => (
            <div key={discomIndex} className={Styles.voltageSection}>
              <div className={Styles.actVoltageLevel}>
                <div>{ele?.voltage?.level}</div>
                <Close
                  style={{
                    fontSize: "12px",
                    color: "red",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    const updatedConsumerDetails = [...consumerDetails];
                    updatedConsumerDetails[index].discom =
                      updatedConsumerDetails[index].discom.filter(
                        (_, i) => i !== discomIndex,
                      );
                    setConsumerDetails(updatedConsumerDetails);
                    handleData("consumerDetails", updatedConsumerDetails);
                  }}
                />
              </div>
              <div className={Styles.discomName}>{ele?.discomId?.acronym}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Bank Details */}
      <div className={Styles.corrAddressContainer}>
        <div
          className={`${Styles.subConterntHeader} ${Styles.corrOtherHeading}`}
        >
          Bank Details
        </div>
        <div className={Styles.corrAddSelection}>
          <div className={Styles.officeSelectionText}>
            <div>
              Same as the <b>Company</b> bank details
            </div>
            <div className={Styles.sel_button}>
              {["Yes", "No"].map((option) => (
                <span
                  key={option}
                  onClick={() => {
                    const updatedConsumerDetails = [...consumerDetails];
                    updatedConsumerDetails[index].bankDifferent =
                      option === "No";
                    setConsumerDetails(updatedConsumerDetails);
                    handleData("consumerDetails", updatedConsumerDetails);
                  }}
                  className={
                    (
                      option === "Yes"
                        ? !consumerDetails[index].bankDifferent
                        : consumerDetails[index].bankDifferent
                    )
                      ? Styles.active_corr
                      : Styles.inAct_corr
                  }
                >
                  {option}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
      <div className={Styles.divider}></div>

      {consumerDetails[index].bankDifferent && (
        <>
          <div className={Styles.layer2ElementsContainer}>
            {renderTextInput(
              index,
              "bankName",
              "Bank Name",
              "Eg. State Bank of India",
            )}
            {renderTextInput(
              index,
              "branchAddress",
              "Bank Address",
              "Eg. 123 Main Street, City",
            )}
          </div>
          <div className={Styles.layer3ElementsContainer}>
            {renderTextInput(
              index,
              "accountNumber",
              "Account Number",
              "Eg. 1234567890",
              "number",
            )}
            {renderTextInput(index, "payee", "Payee Name", "Eg. John Doe")}
            {renderTextInput(index, "ifscCode", "IFSC Code", "Eg. SBIN0001234")}
          </div>
          <div className={Styles.layer3ElementsContainer}>
            {renderTextInput(index, "gst", "GST Number", "Eg. 123456789012345")}
            {renderTextInput(index, "pan", "PAN Number", "Eg. ABCDE1234F")}
            {renderTextInput(index, "tan", "TAN Number", "Eg. ABCDE1234F")}
          </div>
          <div className={Styles.layer3ElementsContainer}>
            {renderFileUpload(
              index,
              "GST Certificate Copy",
              "gstDocId",
              "Upload GST (.pdf accepted)",
              "GST",
              "gstDocId",
            )}
            {renderFileUpload(
              index,
              "PAN Card Copy",
              "panDocId",
              "Upload PAN (.pdf accepted)",
              "PAN",
              "panDocId",
            )}
            {renderFileUpload(
              index,
              "TAN Card Copy",
              "tanDocId",
              "Upload TAN (.pdf accepted)",
              "TAN",
              "tanDocId",
            )}
          </div>
        </>
      )}

      <div className={Styles.conAddressContainer}>
        <div
          className={`${Styles.subConterntHeader} ${Styles.corrOtherHeading}`}
        >
          Registered Address
        </div>
        <div className={Styles.divider}></div>
        <AddressSection
          prefix="registered"
          addressData={consumerDetails[index]}
          handleChange={handleChange}
          errors={errors}
          publicData={publicData}
          index={index}
        />
        <div className={Styles.corrAddressContainer}>
          <div
            className={`${Styles.subConterntHeader} ${Styles.corrOtherHeading}`}
          >
            Correspondence Address
          </div>
          <div className={Styles.corrAddSelection}>
            <div className={Styles.officeSelectionText}>
              <div>Same as that of Office Address</div>
              <div className={Styles.sel_button}>
                <span
                  onClick={() => setSameCheck("same")}
                  className={
                    sameCheck === "same"
                      ? Styles.active_corr
                      : Styles.inAct_corr
                  }
                >
                  Yes
                </span>
                <span
                  onClick={() => setSameCheck("different")}
                  className={
                    sameCheck === "different"
                      ? Styles.active_corr
                      : Styles.inAct_corr
                  }
                >
                  No
                </span>
              </div>
            </div>
          </div>
        </div>
        <div className={Styles.divider}></div>
        {sameCheck === "different" && (
          <AddressSection
            prefix="correspondence"
            addressData={consumerDetails[index]}
            handleChange={handleChange}
            errors={errors}
            publicData={publicData}
            index={index}
          />
        )}
      </div>

      {(totalLength.length === 0 || totalLength.length === 1) && (
        <div className={Styles.AddMoreCont} onClick={handleAddUser}>
          <Add style={{ fontSize: "14px" }} />
          <span>Add New Consumer</span>
        </div>
      )}
    </div>
  );

  return (
    <div className={Styles.elementMain}>
      <div className={Styles.displayInputSection}>
        <div className={`${Styles.conterntHeader} ${Styles.contentHeadGen}`}>
          <span className={Styles.genHeading}>Consumer Details</span>
          <div className={Styles.noteContainer}>
            <b>Note:</b>
            <span>You can Create multiple Consumers </span>
          </div>
        </div>
        <div className={Styles.detailsInpMainContainer}>
          {totalLength.map((ele, index) => renderConsumerDetail(ele, index))}
        </div>
      </div>
      <div className={Styles.buttonSection}>
        <div className={Styles.prevBtn} onClick={() => handleContinue("prev")}>
          Back
        </div>
        <div className={Styles.nextBtn} onClick={() => handleContinue("next")}>
          Next
        </div>
      </div>
    </div>
  );
};

export default ConsumerDetails;
